import React from "react";
import { cn } from "utils";

interface InsightPanelSkeletonProps {
  className?: string;
}

/**
 * InsightPanel 骨架屏组件
 * 在加载状态时显示
 */
export const InsightPanelSkeleton: React.FC<InsightPanelSkeletonProps> = ({
  className,
}) => {
  // 单个卡片骨架屏
  const CardSkeleton = () => (
    <div className="flex flex-col gap-4 flex-1">
      {/* 标题占位符 */}
      <div className="flex items-center">
        <div className="h-5 w-32 bg-background_white_overlay5 rounded animate-pulse" />
      </div>

      {/* 图表区域 */}
      <div className="bg-background_white_overlay5 flex gap-2.5 h-[190px] items-center justify-center p-3 rounded animate-pulse">
        {/* 左侧 Y 轴标签 */}
        <div className="flex flex-col h-full items-start justify-between pb-[43px] pt-0.5 w-6">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="h-3 w-full bg-background_white_overlay5 rounded animate-pulse"
            />
          ))}
        </div>

        {/* 右侧图表区域 */}
        <div className="flex flex-1 flex-col gap-1 h-full items-start">
          {/* 图表主体 */}
          <div className="border-b border-l border-border_solid flex flex-1 flex-col items-start w-full">
            <div className="flex flex-1 flex-col items-start overflow-hidden w-full">
              <div className="flex flex-1 flex-col items-start justify-between pt-2 w-full">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div
                    key={index}
                    className="h-px w-full bg-background_white_overlay5"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* 底部标签 */}
          <div className="flex gap-3 h-3 items-center w-full">
            <div className="flex-1 h-3 bg-background_white_overlay5 rounded animate-pulse" />
            <div className="flex-1 h-3 bg-background_white_overlay5 rounded animate-pulse" />
            <div className="flex-1 h-3 bg-background_white_overlay5 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section
      aria-label="Card Skeleton section"
      data-openreplay-label="Card Skeleton section Semantic"
      id="sem-card-skeleton-section"
      className={cn(
        "flex flex-col gap-3 box-border",
        "md:flex-row md:gap-8 md:px-5 md:pb-5 md:pt-3",
        className,
      )}
    >
      <CardSkeleton />
      <div className="hidden md:self-stretch md:w-px md:bg-border_solid" />
      <CardSkeleton />
    </section>
  );
};
